import "slick-carousel";
import $ from 'jquery';

document.addEventListener("DOMContentLoaded", () => {
  var slider = $(".slick-slider");
  if (!slider) {
    return
  }
  slider.slick()
})